import React from 'react'

import PropTypes from 'prop-types'

import { Box, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles'

const SkeletonCountries = ({ withTable, withAddButton, label }) => {
  const classes = useStyles()

  return (
    <Box>
      {withAddButton ? (
        <Grid container spacing={2} alignItems="stretch">
          {label && (
            <Grid item xs={12}>
              <Skeleton variant="text" width={220} />
            </Grid>
          )}
          <Grid item xs={9} md={10}>
            <Skeleton variant="rect" height={56} className={classes.rounded} />
          </Grid>
          <Grid item xs={3} md={2}>
            <Skeleton variant="rect" height={56} className={classes.rounded} />
          </Grid>
        </Grid>
      ) : (
        <>
          {label && <Skeleton variant="text" width={220} />}
          <Skeleton variant="rect" height={56} className={classes.rounded} />
        </>
      )}
      {withTable && (
        <Box mt={2}>
          <Skeleton variant="rect" height={120} className={classes.rounded} />
        </Box>
      )}
    </Box>
  )
}

SkeletonCountries.propTypes = {
  withTable: PropTypes.bool,
  withAddButton: PropTypes.bool,
  label: PropTypes.string,
}

SkeletonCountries.defaultProps = {
  withTable: false,
  withAddButton: false,
  label: '',
}

export default SkeletonCountries
